module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/05_map#map",
      "id": "rmap"
    }
  }, [_c('em', [_vm._v("Map")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/06_introduction#introduction",
      "id": "rintroduction"
    }
  }, [_c('em', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_preface#preface",
      "id": "rpreface"
    }
  }, [_c('em', [_vm._v("Preface")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter1#ch01",
      "id": "rch01"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter1#ch01"
    }
  }, [_vm._v("The Second Battle of Barfleur")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter2#ch02",
      "id": "rch02"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter2#ch02"
    }
  }, [_vm._v("Conditioning for War")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter3#ch03",
      "id": "rch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coastal Forces")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter4#ch04",
      "id": "rch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting the Hang of It")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter5#ch05",
      "id": "rch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter5#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellrot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter6#ch06",
      "id": "rch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter6#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iron Ore")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter7#ch07",
      "id": "rch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter7#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Softly Catch Monkey")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter8#ch08",
      "id": "rch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter8#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Expect Unsuccessful Attack’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter9#ch09",
      "id": "rch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter9#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back to "), _c('em', [_vm._v("Beehive")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Barrels and the Bullfight")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter11#ch11",
      "id": "rch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Four Horsemen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter12#ch12",
      "id": "rch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hits and Near Misses")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter13#ch13",
      "id": "rch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sad Ending")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_appendix1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendice")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_appendix1#app1",
      "id": "rapp1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_appendix1#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British Ships and Craft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_appendix2#app2",
      "id": "rapp2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_appendix2#app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operational Statistics")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_appendix3#app3",
      "id": "rapp3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_appendix3#app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enemy Ships and Craft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_bibliography#bibliography",
      "id": "rbibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/25_index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a20273","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_contents.vue
// module id = 66
// module chunks = 0